import {
  CLEAR_ONE_PENDING_MESSAGE,
  CLEAR_PENDING_MESSAGE,
  HIDE_FORWARD_MODAL,
  HIDE_MESSAGE_COMPOSER,
  HIDE_MESSAGE_PREVIEW,
  SAVE_PENDING_MESSAGE,
  SET_COMPOSER_TYPE,
  SET_FOCUSED_MESSAGE,
  SHOW_FORWARD_MODAL,
  SHOW_MESSAGE_COMPOSER,
  SHOW_MESSAGE_PREVIEW,
} from '../actions';

import { MessageType } from 'utils/Message';

const defaultState = {
  focusedMessage: null, // FormMessage
  previewing: false,
  composing: false,
  pendingMessage: null, // { type: int, value: string/file }
  editingMessage: null, // { type: int, value: string/file }
  type: MessageType.TEXT,
  showForwardModal: false,
  forwardingMessage: null,
};

export function composer(state = defaultState, action = null) {
  switch (action.type) {
    case SET_COMPOSER_TYPE: {
      return Object.assign({}, state, {
        type: action.tabType,
      });
    }
    case SET_FOCUSED_MESSAGE: {
      return Object.assign({}, state, {
        focusedMessage: action.message,
      });
    }
    case SHOW_MESSAGE_PREVIEW: {
      return Object.assign({}, state, {
        focusedMessage: action.message,
        previewing: true,
        composing: false,
      });
    }
    case HIDE_MESSAGE_PREVIEW: {
      return Object.assign({}, state, {
        previewing: false,
      });
    }
    case SHOW_MESSAGE_COMPOSER: {
      return Object.assign({}, state, {
        // only need focusedM when opening preview, message composer depends on pending message
        composing: true,
        previewing: false,
        editingMessage: action.message,
      });
    }
    case HIDE_MESSAGE_COMPOSER: {
      return Object.assign({}, state, {
        composing: false,
      });
    }
    case SAVE_PENDING_MESSAGE: {
      return Object.assign({}, state, {
        composing: false,
        pendingMessage: action.message,
      });
    }
    case CLEAR_PENDING_MESSAGE: {
      return { ...state, pendingMessage: null };
    }
    case CLEAR_ONE_PENDING_MESSAGE: {
      return {
        ...state,
        pendingMessage: [
          ...state.pendingMessage.slice(0, action.idx),
          ...state.pendingMessage.slice(action.idx + 1),
        ],
      };
    }
    case SHOW_FORWARD_MODAL: {
      return Object.assign({}, state, {
        showForwardModal: true,
        forwardingMessage: action.message,
        forwardCallback: action.callback,
      });
    }
    case HIDE_FORWARD_MODAL: {
      return Object.assign({}, state, {
        showForwardModal: false,
        forwardingMessage: null,
      });
    }
    default: {
      return state;
    }
  }
}



// WEBPACK FOOTER //
// ./app/reducers/composer.js